var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseFeatureLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 487,
    viewBox: "0 0 396 487",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.582 204.262H152.677C150.842 204.262 149.354 205.75 149.354 207.586V207.586C149.354 209.422 150.842 210.91 152.677 210.91H195.582V204.262Z",
    fill: "#FF9900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.98 207.54H70.6873C64.283 207.315 51.4743 201.205 51.4743 178.562V32.3256C51.7945 22.2171 48.4002 2 32.2612 2C16.1222 2 5.36294 2 2.00066 2",
    stroke: "#F39B2D",
    strokeWidth: 2.08212,
    strokeLinecap: "round",
    strokeDasharray: "5.21 5.21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.582 282.728H154.53C152.694 282.728 151.206 281.24 151.206 279.404V279.404C151.206 277.568 152.694 276.08 154.53 276.08H193.582V282.728Z",
    fill: "#326CE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.582 279.465H72.8896C66.4526 279.691 53.5785 285.829 53.5785 308.575V455.476C53.9004 465.63 50.4888 485.939 34.2675 485.939C18.0462 485.939 7.23205 485.939 3.85262 485.939",
    stroke: "#326CE5",
    strokeWidth: 2.08212,
    strokeLinecap: "round",
    strokeDasharray: "5.21 5.21"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.582 239.939H144.899C143.063 239.939 141.575 241.427 141.575 243.263V243.263C141.575 245.099 143.063 246.587 144.899 246.587H193.582V239.939Z",
    fill: "#59C7AE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M148.146 242.788H3.85278",
    stroke: "#59C7AE",
    strokeWidth: 2.08212,
    strokeLinecap: "round",
    strokeDasharray: "5.21 5.21"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M205 205.11H244.007C245.867 205.11 247.376 206.619 247.376 208.48V208.48C247.376 210.341 245.867 211.849 244.007 211.849H205V205.11Z",
    fill: "#2F69DE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M247.75 208.48H326.043C332.448 208.255 345.256 202.145 345.256 179.502V33.265C344.936 23.1565 348.33 2.93945 364.469 2.93945C380.608 2.93945 391.368 2.93945 394.73 2.93945",
    stroke: "#326CE5",
    strokeWidth: 2.08212,
    strokeLinecap: "round",
    strokeDasharray: "5.21 5.21"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M205 283.769H244.223C246.084 283.769 247.592 282.26 247.592 280.399V280.399C247.592 278.538 246.084 277.03 244.223 277.03H205V283.769Z",
    fill: "#F39B2D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M247 280.399H325.693C332.13 280.624 345.004 286.734 345.004 309.377V455.614C344.682 465.722 348.093 485.939 364.315 485.939C380.536 485.939 391.35 485.939 394.73 485.939",
    stroke: "#F39B2D",
    strokeWidth: 2.08212,
    strokeLinecap: "round",
    strokeDasharray: "5.21 5.21"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M209 240.939H249.614C251.449 240.939 252.937 242.427 252.937 244.263V244.263C252.937 246.099 251.449 247.587 249.614 247.587H209V240.939Z",
    fill: "#59C7AE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M246.73 243.788H391.025",
    stroke: "#59C7AE",
    strokeWidth: 2.08212,
    strokeLinecap: "round",
    strokeDasharray: "5.21 5.21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFeatureLines);
export default __webpack_public_path__ + "static/media/close-feature-lines.4f9f96e3d11f7b3b5d7a2065427b529f.svg";
export { ForwardRef as ReactComponent };